export default "__VITE_ASSET__DUFQnb0X__"